import { client } from '@api/client';

export async function getBlockedUsersPaginated(cursor?: number, limit?: number) {
    return client.GET('/user-relation/blocked/list', {
        params: {
            query: {
                cursor,
                limit,
            },
        },
    });
}

export async function getBlockedByUsersPaginated(cursor?: number, limit?: number) {
    return client.GET('/user-relation/blockedBy/list', {
        params: {
            query: {
                cursor,
                limit,
            },
        },
    });
}

export async function toggleBlock(userId: string): Promise<{ ok: boolean }> {
    const response = await client.PATCH('/user-relation/toggle-blocked', {
        body: {
            userId,
        },
    });
    return {
        ok: response.response.ok,
    };
}
